import React from 'react';
import { Icons } from '@citygross/icons';
import { getPriceTagAttributes } from '../../helpers/price.js';
import { PriceStripe } from '../PriceStripe/PriceStripe.js';
import { PriceTagWrapper, PriceStripeContainer, PriceTagContainer, PriceTag as PriceTag$1, PriceBase, PriceDetails, PriceIndicatorContainer, PriceDecimals, PriceUnit } from './PriceTag.styles.js';
import { EPriceVariant, EPriceSize } from './PriceTag.types.js';

var PriceTag = function PriceTag(_a) {
  var _b = _a.multiPrice,
      multiPrice = _b === void 0 ? 0 : _b,
      _c = _a.pant,
      pant = _c === void 0 ? false : _c,
      price = _a.price,
      _d = _a.variant,
      variant = _d === void 0 ? EPriceVariant.REGULAR : _d,
      _e = _a.size,
      size = _e === void 0 ? EPriceSize.MEDIUM : _e,
      unit = _a.unit;

  var _f = getPriceTagAttributes(size, variant),
      sizeAttributes = _f.sizeAttributes,
      variantAttributes = _f.variantAttributes;

  var isMultiPrice = multiPrice > 1;
  var pantStr = '+pant';
  var priceBase = Math.floor(price);
  var priceDecimals = (price % 1).toFixed(2).split('.')[1];
  var showPriceIndicator = priceDecimals === '00';
  var showUnit = pant || unit !== undefined && !(isMultiPrice && unit === 'st' || isMultiPrice && unit === 'kg');
  return React.createElement(PriceTagWrapper, {
    fontColor: variantAttributes.fontColor
  }, variant !== EPriceVariant.REGULAR && React.createElement(PriceStripeContainer, null, React.createElement(PriceStripe, {
    multiPrice: multiPrice,
    size: size,
    unit: unit,
    variant: variant
  })), React.createElement(PriceTagContainer, {
    backgroundColor: variantAttributes.backgroundColor
  }, React.createElement(PriceTag$1, null, React.createElement(PriceBase, {
    fontSize: sizeAttributes.baseFontSize
  }, priceBase), React.createElement(PriceDetails, {
    width: pant ? sizeAttributes.detailsPantWidth : sizeAttributes.detailsNoPantWidth
  }, showPriceIndicator ? React.createElement(PriceIndicatorContainer, {
    isSmall: size === EPriceSize.SMALL,
    showUnit: showUnit
  }, React.createElement(Icons.PriceIndicator, {
    fill: variantAttributes.fontColor,
    size: sizeAttributes.indicatorSize
  })) : React.createElement(PriceDecimals, {
    fontSize: sizeAttributes.decimalsFontSize,
    isSmall: size === EPriceSize.SMALL
  }, priceDecimals), React.createElement(PriceUnit, {
    fontSize: sizeAttributes.unitFontSize,
    isSmall: size === EPriceSize.SMALL,
    pant: pant
  }, pant ? pantStr : isMultiPrice ? '' : unit ? "/".concat(unit) : '')))));
};

export { PriceTag };